import * as React from 'react';

// @ts-ignore
import LinkDeviceModal from 'user/components/LinkDeviceModal';
import Menu from 'components/Menu';
import MenuButton from 'components/MenuButtonDeprecated';
import ModalMenuItem from 'components/ModalMenuItem';
// @ts-ignore
import TextAppLinkDialog from 'user/components/TextAppLinkDialog';
import TextWithGlyph from 'components/TextWithGlyph';

export type Props = {
  onAddDevice: () => void;
};

export default function AddDeviceMenuButton(props: Props) {
  const { onAddDevice } = props;
  const emptyHandleRequestHide = () => {};

  const menu = (
    <Menu>
      <ModalMenuItem
        menuKey="phone"
        modal={
          <LinkDeviceModal
            deviceType="phoneNumber"
            onDone={onAddDevice}
            onRequestHide={emptyHandleRequestHide}
          />
        }>
        Phone number
      </ModalMenuItem>
      <ModalMenuItem
        menuKey="email"
        modal={
          <LinkDeviceModal
            deviceType="email"
            onDone={onAddDevice}
            onRequestHide={emptyHandleRequestHide}
          />
        }>
        Email
      </ModalMenuItem>
      <ModalMenuItem
        menuKey="app"
        modal={<TextAppLinkDialog onRequestHide={emptyHandleRequestHide} />}>
        Remind mobile app
      </ModalMenuItem>
    </Menu>
  );

  return (
    <MenuButton menu={menu} level="secondary">
      <TextWithGlyph glyph="plus">Add device</TextWithGlyph>
    </MenuButton>
  );
}
